import { RefetchOnComplete } from '@graphql/helpers/effects';
import {
  ChannelStatsDocument,
  gql,
  SetChannelNotificationsDocument,
  useMutation,
} from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  mutation SetChannelNotifications($channelId: UUID!, $status: ChannelNotificationStatus!) {
    setUserNotificationPreferencesOnChannel(channelId: $channelId, status: $status) {
      __typename
      ... on Error {
        message
      }
    }
  }
`);

RefetchOnComplete({
  trigger: [SetChannelNotificationsDocument],
  refetch: [ChannelStatsDocument],
});

export function useChannelNotifications() {
  const { mutateAsync: setChannelNotificationPreferences, isLoading } = useMutation(
    SetChannelNotificationsDocument,
    {
      retry: 5,
    },
  );

  return { setChannelNotificationPreferences, isLoading };
}
